<template>
  <DpplTooltip
    tooltip-placement="bottom"
  >
    <template #activator="{ onMouseenter, onMouseleave }">
      <h5
        class="lever-message-activator"
        @mouseenter="onMouseenter"
        @mouseleave="onMouseleave"
      >
        Important note about requisitions.
      </h5>
    </template>
    <template #tooltip-content>
      <div>
        <b>
          For Lever customers, the Requisition Progress Report
          shows activity for individual Lever Postings.
        </b>
        Lever Posting objects allow for clearer candidate analytics
        than Lever Requisition objects.
        <a
          class="lever-message-link"
          href="#"
          data-beacon-article-sidebar="6744e7bcfaffbb5b351648d7"
          @click.stop
        >
          Learn more about this decision here.
        </a>
      </div>
    </template>
  </DpplTooltip>
</template>

<script setup>
import DpplTooltip from '@/components/datapeople/DpplTooltip.vue';
</script>

<style lang="less" scoped>
.lever-message-activator {
  color: @text-brand;
  white-space: nowrap;
}

.lever-message-link {
  color: @text-brand;
  font-weight: 500;
  cursor: pointer;
  text-decoration: none;
}
</style>
